<template>
  <div class="zoom-image"
       @mouseenter="hovered = true"
       @mousemove="mousemove"
       @mouseleave="hovered = false">
    <img class="image" :src="image">
    <img class="hover-image" :src="image"
         :style="style">
  </div>
</template>

<script>
const IDE = window['IDE']

export default {
  props: ['image'],
  data () {
    return {
      container: { width: 0, height: 0 },
      real: { width: 0, height: 0 },
      mouse: { x: 0, y: 0 },
      hovered: false,
      IDE
    }
  },
  watch: {
    'IDE.layout' () {
      setTimeout(() => {
        this.container.width = this.$el.clientWidth
        this.container.height = this.$el.clientHeight
      }, 300)
    }
  },
  computed: {
    style () {
      const left = this.mouse.x / (this.container.width || 1)
      const top = this.mouse.y / (this.container.height || 1)
      return {
        display: this.hovered && this.real.width > this.container.width ? 'block' : 'none',
        width: this.real.width + 'px',
        height: this.real.height + 'px',
        transform: `translate(${-(this.real.width - this.container.width) * left}px, ${-(this.real.height - this.container.height) * top}px)`
      }
    }
  },
  mounted () {
    const newImg = new Image()
    newImg.onload = () => {
      this.real = {
        width: newImg.width,
        height: newImg.height
      }

      setTimeout(() => {
        this.container.width = this.$el.clientWidth
        this.container.height = this.$el.clientHeight
      }, 300)

    }
    newImg.src = this.image // this must be done AFTER setting onload
  },
  methods: {
    mousemove ($event) {
      this.mouse.x = $event.layerX
      this.mouse.y = $event.layerY
    }
  }
}
</script>

<style lang="stylus" scoped>
.zoom-image {
  width 100%
  display flex
  justify-content center
  align-items center
  position relative
  overflow hidden
}

.image {
  max-height 100%
  max-width 100%
}

.hover-image {
  width 100%
  position absolute
  left 0
  top 0
  max-width none
  cursor zoom-in
}
</style>
